// トップの背景暗転・追従表示・スクロール演出をまとめて初期化する
export function initHome($) {
  const home = document.querySelector('.js-home');
  if (!home) return;
  const intro = home.querySelector('.js-home-intro');
  const introBackground = intro.querySelector('.p-home-intro__background');
  const hero = home.querySelector('.p-home-hero');
  // FVのコピーはスクロール判定と分け、ローディング後の余韻に続けて下から表示する。
  revealHomeCopy(hero.querySelector('.p-home-hero__copy'));
  const order = document.querySelector('.p-home-order');
  const pagetop = document.querySelector('.l-footer__pagetop');
  const backgroundLogos = [
    home.querySelector('.p-home-products__background-logo--first'),
    home.querySelector('.p-home-products__background-logo--last'),
    home.querySelector('.p-home-products__background-logo--middle'),
    home.querySelector('.p-home-products__background-logo--lower'),
  ].filter(Boolean);
  let orderStop = 0;
  let orderBottom = 0;
  let viewportHeight = window.innerHeight;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let scheduled = false;
  let lastDarkness = null;
  let lastOrderOffset = null;
  let heroHeight = hero.offsetHeight;
  let introTop = intro.getBoundingClientRect().top + window.scrollY;

  // 高さはレイアウト更新時に測定し、スクロール処理は1フレームに1回だけ実行する
  function updateScroll() {
    const scroll = window.scrollY;
    const progress = Math.min(1, Math.max(0, (scroll - introTop) / heroHeight));
    const darkness = reducedMotion.matches ? .55 : .4 + progress * .32;
    if (introBackground && darkness !== lastDarkness) {
      introBackground.style.setProperty('--intro-darkness', darkness);
      lastDarkness = darkness;
    }
    // フッターではCTAの下端をページトップの少し上に留める
    if (order && pagetop) {
      const offset = Math.max(0, scroll + viewportHeight - orderBottom - orderStop);
      if (offset !== lastOrderOffset) {
        order.style.setProperty('--home-order-offset', offset + 'px');
        lastOrderOffset = offset;
      }
    }
    scheduled = false;
  }
  $(window).on('scroll.home', function () {
    if (!scheduled) { scheduled = true; window.requestAnimationFrame(updateScroll); }
  }).on('resize.home', measureLayout);
  function measureLayout() {
    updateBackgroundLogos();
    heroHeight = hero.offsetHeight;
    introTop = intro.getBoundingClientRect().top + window.scrollY;
    if (order && pagetop) {
      const orderStyle = window.getComputedStyle(order);
      orderBottom = parseFloat(orderStyle.bottom) || 0;
      const orderGap = parseFloat(orderStyle.getPropertyValue('--home-order-gap')) || 0;
      orderStop = pagetop.getBoundingClientRect().top + window.scrollY - orderGap;
      viewportHeight = window.innerHeight;
    }
    updateScroll();
  }

  // 上下端のロゴを優先し、円形ロゴ同士が重なる配置は高さが確保できるまで非表示にする
  function updateBackgroundLogos() {
    const visibleLogos = [];
    backgroundLogos.forEach(function (logo) {
      const width = logo.offsetWidth;
      const height = logo.offsetHeight;
      if (!width || !height) {
        logo.classList.remove('is-overlapping');
        return;
      }
      const circle = {
        x: logo.offsetLeft + width / 2,
        y: logo.offsetTop + height / 2,
        radius: Math.max(width, height) / 2,
      };
      const overlapping = visibleLogos.some(function (visible) {
        return Math.hypot(circle.x - visible.x, circle.y - visible.y) < circle.radius + visible.radius;
      });
      logo.classList.toggle('is-overlapping', overlapping);
      if (!overlapping) visibleLogos.push(circle);
    });
  }
  measureLayout();
  if (document.fonts) document.fonts.ready.then(measureLayout);
  // 遅延画像やフォントで高さが変わった場合も、CTAの停止位置を合わせ直す
  if ('ResizeObserver' in window) {
    const layoutObserver = new ResizeObserver(measureLayout);
    [home, pagetop, document.querySelector('.l-footer')].forEach(function (element) {
      if (element) layoutObserver.observe(element);
    });
  }

  // 見出し・本文・非同期で追加した商品を、それぞれ表示範囲でフェードインする
  if ('IntersectionObserver' in window && !reducedMotion.matches) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < .18) return;
        entry.target.classList.remove('is-pending');
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .18, rootMargin: '0px 0px -48px 0px' });
    function observeContent() {
      document.querySelectorAll('.js-home-reveal:not(.p-home-reveal)').forEach(function (element) {
        element.classList.add('p-home-reveal', 'is-pending');
        observer.observe(element);
      });
      measureLayout();
    }
    observeContent();
    $(document).on('home:content-updated', observeContent);

    // 横にはみ出すスタンプは全幅の領域で判定し、画面内へ十分入ってから押印する
    const stampObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < .75) return;
        const stamp = entry.target.querySelector('.js-home-stamp');
        stamp.classList.remove('is-pending');
        stamp.classList.add('is-visible');
        stampObserver.unobserve(entry.target);
      });
    }, { threshold: .75, rootMargin: '0px 0px -96px 0px' });
    home.querySelectorAll('.js-home-stamp-area').forEach(function (area) {
      area.querySelector('.js-home-stamp').classList.add('p-home-stamp', 'is-pending');
      stampObserver.observe(area);
    });
  } else {
    $(document).on('home:content-updated', measureLayout);
  }
}

// 初回・再訪とも画像のデコードを待ち、非表示の初期状態から一度だけ演出を始める。
function revealHomeCopy(copy) {
  const root = document.documentElement;
  if (!copy || !root.classList.contains('is-home-copy-pending')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.remove('is-home-copy-pending');
    return;
  }

  function start() {
    window.clearTimeout(timeout);
    if (!root.classList.contains('is-home-copy-pending')) return;
    copy.classList.add('is-visible');
    root.classList.remove('is-home-copy-pending');
  }
  // 画像の取得が停止しても、コピーの表示待機を3秒で終える。
  const timeout = window.setTimeout(start, 3000);
  const image = copy.querySelector('img');
  if (image) image.decode().catch(function () {}).then(start);
  else start();
}
